export default "__VITE_ASSET__CWWJFBeF__"